import Web3 from "web3";
import {getSid} from "@/utils/api"
import request from "../utils/request";
import {methods} from "babel-plugin-transform-runtime/lib/definitions";

const action = {
  increment(context) {
    context.commit('increment')
  },
  async initChain(context) {
    if (window.chain=="BTC"){
      context.commit('setChainId', 80000);
      return;
    }
    let chainId = await context.state.provider.request({method: 'eth_chainId'});
    chainId = parseInt(chainId, 16)
    context.commit('setChainId', chainId);
  },
  async getAccounts(context) {
    if (window.chain=="BTC"){

    }else {
      let accounts = await web3.eth.getAccounts();
      context.commit("setAccounts", accounts);
    }

  },
  async connectWallet(context, val) {
    if(!val){
      return;
    };
    let accounts;
    let provider;
    if(val=="MetaMask"){
      //console.log("MetaMask")
      const MetaMaskProvider = window.ethereum;
      //console.log(MetaMaskProvider)
      provider=MetaMaskProvider;
    }else if(val=="BitKeep"){
      console.log("BitKeep")
      const BitKeepProvider = window.bitkeep && window.bitkeep.ethereum;
      if (!BitKeepProvider) {
        return window.open('https://bitkeep.com/en/download?type=2');
      }
      provider=BitKeepProvider;
    }else if(val=="OKX"){
      console.log("OKX")
      const OkxProvider = window.okxwallet;
      if (!OkxProvider) {
        return window.open('https://www.okx.com/cn/web3');
      }
      provider=OkxProvider;
    }/*else if(val=="OKX BTC"){
      const result = await okxwallet.bitcoin.connect()
      context.commit("setAccounts", [result.address,""]);
      if (typeof window.okxwallet == 'undefined') {
        return window.open('https://www.okx.com/cn/web3');
      }
      provider=result;
      /!*await window.okxwallet.bitcoin.send({
        from: result.address,
        to: 'bc1pcr4nnh0599feqlcrk8z7376rjy3tgzenxrj4c5dgjktddjyrd9ts6t3wfn',
        value: '0.000012'
      });*!/
    }*/

    if(provider){
      if (val=="OKX BTC"){
        window.chain="BTC";
      }else {
        localStorage.setItem("selectWallet",val);
        // // provider.removeAllListeners();
        context.commit("setProvider", provider);



          accounts = await provider.request({method: 'eth_requestAccounts'});

          context.commit("setAccounts", accounts);
          window.chain="ETH";

        let web3 = new Web3(provider);
        window.web3 = web3;

        //遇到钱包多账户切换的时候，需要使用监听事件
        /*provider.on("accountsChanged", function(accounts) {
          console.log('钱包切换',accounts)
        });*/
        //当所连接网络ID变化时触发
        provider.on("chainChanged",(networkIDstring)=>{
          if(context.state.isReload){
            window.location.reload();
          }else{
            this.$store.commit("setReload",true)
          }
        });
      }
      await context.dispatch("initChain");

      await context.dispatch("getBalance");
    }
  },
  async getBalance(context) {
    /*if (window.chain=="BTC"){
      context.commit("setBalance", 0);
      await context.dispatch("getSid");
      return;
    }*/
    let myAccount = context.getters.getMyAccount;
    let balance = await web3.eth.getBalance(myAccount);
    context.commit("setBalance", balance);
    await context.dispatch("getSid");
  },

  async getSid(context) {
    /*if (context.state.chainId==80000){
      let sid=context.getters.getMyAccount.substring(0,5)+'...'+context.getters.getMyAccount.substring(context.getters.getMyAccount.length - 5);
      console.log("getSid==========",context.getters.getMyAccount)
      context.commit("setSid", sid);
      return;
    }*/
    let queryParams = {
      account: context.getters.getMyAccount,
    }
    let res = await getSid(queryParams);
    let sid=context.getters.getMyAccount.substring(0,5)+'...'+context.getters.getMyAccount.substring(context.getters.getMyAccount.length - 5);
    let profileSid=context.getters.getMyAccount;

    if(context.state.chainId==56 && (res.data.SpaceId+"").length <= 38){
      sid = res.data.SpaceId;
      profileSid = res.data.SpaceId;
    }
    if(context.state.chainId==1 && (res.data.BitID+"").length <= 38){
      sid = res.data.BitID;
      profileSid = res.data.BitID;
    }
    context.commit("setSid", sid);
    context.commit("setProfileSid", profileSid);

  },

  async swatchChainId(context, chainID) {
    console.log("swatchChainId", chainID)
    if (chainID != this.chainId) {
      try {
        await context.state.provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{
            chainId: web3.utils.numberToHex(chainID)
          }]
        })
        context.commit("setReload", false);
        context.commit("setChainId", chainID);
      } catch (e) {
        console.log("wallet_switchEthereumChain", e)
      }
    }
    await context.dispatch("getBalance");
  }
}
export default action



// WEBPACK FOOTER //
// ./src/store/actions.js